const localizers = {
  'loading.msg': () => `Laden...`,
  'SASServer.genericError.msg': () => `De server is niet bereikbaar.`,
  'SASReport.genericError.msg': () => `Het geselecteerde rapport kan niet worden geladen.`,
  'SASReportImage.genericError.msg': () => `De rapportafbeelding kan niet worden geladen.`,
  'SASReportImage.imageNotSupported.msg': () => `Afbeeldingen worden niet ondersteund voor dit type rapportinhoud.`,
}
export default localizers;
